<template>
  <div class="warningRecordWrap mainPageBg" v-loading="$store.state.user.loadingState">
    <div class="recordContent commonOrderContent">
      <div class="formBox recordContent-top">
        <DatePickerRange @dateChange="dateChange" :size="'mini'" />
        <div><el-button type="primary" size="mini" style="margin-left: 10px;" @click="currentPage = 1;
        getAlarmsList();
                                                                                            ">查询</el-button>
          <el-button type="primary" size="mini" plain @click=" exportExcel "><i class="el-icon-download el-icon--left"></i>EXCEL</el-button>
        </div>
      </div>
      <div class="tabCardBox recordContent-content">
        <AlarmTableCom :tabHead=" tabHead " :tableData=" tableList " ref="componentAlarmTable" showCheckbox selectableAlways/>
        <el-pagination @size-change=" handleSizeChange " @current-change=" handleCurrentChange " :current-page=" currentPage "
          :page-sizes=" [10, 30, 50] " :page-size=" page.size " layout="total, sizes, prev, pager, next, jumper"
          :total=" page.total " style="margin-top: 10px; text-align: right">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DialogForm from "@/components/houqinguanli/gongdanguanli/DialogForm.vue";
import HandleDialogCom from "@/components/houqinguanli/gongdanguanli/HandleDialogCom.vue";
import OrderDetails from "@/components/houqinguanli/gongdanguanli/OrderDetails";
import DatePickerRange from '@/components/DatePicker/DatePickerRange';
import api from "@/api";
import { matchingOrderColor, exportExcelFun } from "@/assets/js/utils";
import { dateFtt, matchingAlarmLevel } from "@/assets/js/utils";
import exportFile from "@/assets/js/xlsxFile";
import XLSX from "xlsx";
import AlarmTableCom from "@/components/AlarmTableCom";
export default {
  name: "WarningRecord",
  props: {
    activeItem: {
      type: Object,
      default: () => { },
    },
  },
  components: {
    DatePickerRange,
    DialogForm,
    HandleDialogCom,
    OrderDetails,
    AlarmTableCom,
  },
  data() {
    return {
      startTime: this.$moment().startOf("day").format("x"),
      endTime: this.$moment(new Date()).format("x"),
      tableList: [],
      tabHead: [
        { label: "ID", prop: "alarmId" },
        { label: "报警时间", prop: "alarmEndTime" },
        { label: "报警类型", prop: "type" },
        { label: "报警条件", prop: "condition" },
        { label: "当前状态", prop: "status" },
        { label: "正常范围", prop: "range" },
        { label: "确认状态", prop: "handleState" },
        { label: "报警级别", prop: "alarmSeverity" },
      ],
      currentPage: 1,
      page: {
        total: null,
        size: 10,
      },
      orderDetails: false,
      drawerState: false,

      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
      selectItem: {},
      multipleSelection: [],
      handleDialog: false,
      roleAuthority: false,
    };
  },
  methods: {
    dateChange(value) {
      this.startTime = this.$moment(value[0]).startOf('day').format('x')
      this.endTime = this.$moment(value[1]).endOf('day').format('x')
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.currentPage = 1;
      this.getAlarmsList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getAlarmsList();
    },
    async getAlarmsList() {
      this.tableList = [];
      this.$store.commit("SET_LOADING", true);
      let res = await api.DMGetAlarmsPageList({
        pageSize: this.page.size,
        page: this.currentPage - 1,
        key: this.activeItem?.id?.id || this.activeItem?.deviceId,
        beginTs: this.startTime,
        endTs: this.endTime,
      });
      if (res && res.data.code == 200) {
        this.$store.commit("SET_LOADING", false);
        this.page.total = res.data.data.totalElements;
        this.tableList = res.data.data.data;
        this.tableList.map((v) => {
          v.alarmEndTime = dateFtt("yyyy-MM-dd hh:mm:ss", new Date(v.endTime));
          v.handleState = v.confirm ? "已确认" : "未确认";
          v.alarmSeverity = matchingAlarmLevel(v.level);
        });
      }
    },
    exportExcel() {
      if (this.$refs.componentAlarmTable.multipleSelection.length == 0) {
        this.$message.error("没有可导出的数据!");
        return false;
      }

      let excelTitle = `${this.activeItem?.name || ""}报警记录_${this.$moment(
        Number(this.startTime)
      ).format("yyyy-MM-DD")}-${this.$moment(Number(this.endTime)).format(
        "yyyy-MM-DD"
      )}`;
      exportFile.xlsxFile(XLSX, excelTitle, {
        excel: exportExcelFun(this.tabHead, this.$refs.componentAlarmTable.multipleSelection),
      });
    },
  },
  created() {
    this.getAlarmsList();
  },
};
</script>

<style lang="scss" scoped>
.warningRecordWrap {
  @include setFlexCenter;

  ::v-deep .cell {
    .el-tooltip {
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      word-break: break-all;
    }
  }

  .recordContent {
    width: 100%;
    height: 100%;

    // ::v-deep .el-select .el-input {
    //   width: 120px;
    // }

    ::v-deep .el-tabs__content {
      height: calc(100% - 50px);
    }

    &-top {
      @include setFlexBetween;
      width: 96%;
      margin: 0 auto;
      height: 50px;
    }

    &-content {
      height: calc(100% - 60px);
    }
  }

  ::v-deep .el-descriptions {
    th {
      width: 120px;
    }
  }
}
</style>